import { PluginProps } from "types";
import { RootStateOrAny } from "react-redux";

interface ConfigurationState {
  plugins: PluginProps[];
  selectedPluginIndex: number;
}

export const configurations = {
  state: { plugins: [], selectedPluginIndex: -1 },
  reducers: {
    setPlugins: (currentState: ConfigurationState, newConfigurationPlugins: PluginProps[]) => {
      const newConfigurations = { ...currentState, plugins: newConfigurationPlugins };

      return newConfigurations;
    },
    setSelectedPluginIndex: (currentState: PluginProps[], selectedPluginIndex: number) => {
      const newConfigurations = { ...currentState, selectedPluginIndex };

      return newConfigurations;
    }
  },
  effects: () => {
    return {
      getPlugin: (payload, rootState: RootStateOrAny) => {
        const plugin = rootState.configurations.plugins[rootState.configurations.selectedPluginIndex];

        return plugin;
      }
    };
  }
};

export default configurations;
